import { ref } from "vue";
import { useToast } from "./useToast";

export function useReservationConflict() {
  const toast = useToast();
  const reservationDialog = ref(false);
  const reservationConflicts = ref([]);
  const reservationLoading = ref(false);
  let retry = null;

  const isReservationConflict = (err) => err?.response?.data?.cod === "MSG2118";

  function catchReservationConflict(err, onOverride) {
    if (!isReservationConflict(err)) return false;
    reservationConflicts.value = err.response.data.conflicts || [];
    retry = onOverride;
    reservationDialog.value = true;
    return true;
  }

  async function saveOverridingReservation() {
    const run = retry;
    retry = null;
    reservationLoading.value = true;
    try {
      if (run) await run();
    } finally {
      reservationLoading.value = false;
      // o reenvio pode ter aberto o diálogo de novo com outro conflito
      if (!retry) reservationDialog.value = false;
    }
  }

  // modo "só avisa" e liberação do gestor: gravou, mas acima do disponível
  function warnReservationConflicts(res) {
    const conflicts = res?.data?.equipment_reservation_conflicts || [];
    if (!conflicts.length) return;
    toast.warning(`Salvo acima do disponível no período: ${conflicts.map((c) => c.product).join(", ")}`);
  }

  return {
    reservationDialog,
    reservationConflicts,
    reservationLoading,
    isReservationConflict,
    catchReservationConflict,
    saveOverridingReservation,
    warnReservationConflicts,
  };
}
